import ReportDetailFeature from "./ReportDetailFeature";

export default ReportDetailFeature;
